import { render, staticRenderFns } from "./StudentOrganizations.vue?vue&type=template&id=5c4cf029&scoped=true&"
import script from "./StudentOrganizations.vue?vue&type=script&lang=js&"
export * from "./StudentOrganizations.vue?vue&type=script&lang=js&"
import style0 from "./StudentOrganizations.vue?vue&type=style&index=0&id=5c4cf029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4cf029",
  null
  
)

export default component.exports